export const REQUEST_QUESTIONNAIRES = 'REQUEST_QUESTIONNAIRES';
export const RECEIVE_QUESTIONNAIRES = 'RECEIVE_QUESTIONNAIRES';

export const ANSWER_QUESTION = 'ANSWER_QUESTION';

export const RECEIVE_QUESTIONNAIRE_RESULT = 'RECEIVE_QUESTIONNAIRE_RESULT';